import { useEffect, useCallback } from 'react';
import { useRoutes } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { setActivePermissions } from './store/dictionaries/slice';
import BankAndPspRoutes from './routes/bank-and-psp';
import TariffsRoutes from './routes/tariffs';
import FeesRoutes from './routes/fees';
import CardsRoutes from './routes/cards';
import CurrenciesRoutes from './routes/currencies';
import IntegrationLogsRoutes from './routes/integration-logs';
import {
  useLazyGetConfigurationPermissionsQuery,
  useLazyGetConfigurationWhitelabelQuery,
  useLazyGetConfigurationPaymentTypesQuery,
  useLazyGetConfigurationBaseCurrencyQuery,
  useLazyGetConfigurationCountriesQuery,
  useLazyGetDictionariesConfigurationCurrenciesQuery,
  useLazyGetConfigurationDictionariesQuery,
} from './store/dictionaries/service';

export const routes = [
  BankAndPspRoutes,
  TariffsRoutes,
  FeesRoutes,
  CardsRoutes,
  CurrenciesRoutes,
  IntegrationLogsRoutes,
];

const ConfigurationRoutes = () => {
  const elements = useRoutes(routes);

  const dispatch = useAppDispatch();

  const {
    activePermissions,
    whitelabel,
    paymentTypes,
    currencies,
    countries,
    baseCurrency,
    riskScoreRanges,
  } = useAppSelector((state) => state.configurationDictionaries);

  const [getConfigurationPermissions] =
    useLazyGetConfigurationPermissionsQuery();
  const [getConfigurationWhiteLabel] = useLazyGetConfigurationWhitelabelQuery();
  const [getConfigurationBaseCurrency] =
    useLazyGetConfigurationBaseCurrencyQuery();
  const [getConfigurationCountries] = useLazyGetConfigurationCountriesQuery();
  const [getDictionariesConfigurationCurrencies] =
    useLazyGetDictionariesConfigurationCurrenciesQuery();
  const [getDictionaries] = useLazyGetConfigurationDictionariesQuery();

  const getConfigurationPermissionsAction = useCallback(() => {
    getConfigurationPermissions();
  }, []);

  const [getConfigurationPaymentTypes] =
    useLazyGetConfigurationPaymentTypesQuery();

  const permissions = JSON.parse(
    localStorage.getItem('activePermissions') as string,
  );

  useEffect(() => {
    const companyName = localStorage.getItem('companyName');

    if (!companyName) {
      getConfigurationWhiteLabel();
    }
  }, []);

  useEffect(() => {
    if (!currencies) {
      getDictionariesConfigurationCurrencies();
    }

    if (!countries) {
      getConfigurationCountries();
    }

    if (!baseCurrency) {
      getConfigurationBaseCurrency();
    }

    if (!riskScoreRanges) {
      getDictionaries();
    }
  }, [currencies, countries, baseCurrency, riskScoreRanges]);

  useEffect(() => {
    if (!paymentTypes) {
      getConfigurationPaymentTypes();
    }
  }, [paymentTypes]);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  useEffect(() => {
    if (permissions && !activePermissions) {
      dispatch(setActivePermissions(permissions));
    } else if (!permissions && !activePermissions) {
      getConfigurationPermissionsAction();
    }
  }, [
    permissions,
    getConfigurationPermissionsAction,
    dispatch,
    activePermissions,
  ]);

  return elements;
};

export default ConfigurationRoutes;
